import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";
import {
  DARK_THEME_INPUT_OUTLINE_COLOR,
  DARK_THEME_DISABLED_TEXT_COLOR,
  DARK_THEME_TEXT_COLOR,
  DARK_THEME_PAPER_COLOR,
  LIGHT_THEME_TEXT_COLOR,
  LIGHT_THEME_DISABLED_TEXT_COLOR,
  LIGHT_THEME_PAPER_COLOR,
} from "../constants";

const ThemedAutocomplete = ({ sx, disabled, ...rest }) => {
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);

  return (
    <Autocomplete
      sx={{
        ...sx,
        "& input, & textarea": {
          backgroundColor: darkThemeEnabled
            ? DARK_THEME_PAPER_COLOR
            : LIGHT_THEME_PAPER_COLOR,
          color: disabled
            ? darkThemeEnabled
              ? DARK_THEME_DISABLED_TEXT_COLOR
              : LIGHT_THEME_DISABLED_TEXT_COLOR
            : darkThemeEnabled
              ? DARK_THEME_TEXT_COLOR
              : LIGHT_THEME_TEXT_COLOR,
        },
        "& label": {
          color: disabled
            ? darkThemeEnabled
              ? DARK_THEME_DISABLED_TEXT_COLOR
              : LIGHT_THEME_DISABLED_TEXT_COLOR
            : darkThemeEnabled
              ? DARK_THEME_TEXT_COLOR
              : LIGHT_THEME_TEXT_COLOR,
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            ...(darkThemeEnabled && {
              borderColor: DARK_THEME_INPUT_OUTLINE_COLOR,
            }),
          },
        },
        "& .MuiInputBase-root": {
          backgroundColor: darkThemeEnabled
            ? DARK_THEME_PAPER_COLOR
            : LIGHT_THEME_PAPER_COLOR,
        },
        "& .MuiInputAdornment-root": {
          color: darkThemeEnabled
            ? DARK_THEME_TEXT_COLOR
            : LIGHT_THEME_TEXT_COLOR,
        },
        "& .MuiSvgIcon-root": {
          color: darkThemeEnabled
            ? DARK_THEME_TEXT_COLOR
            : LIGHT_THEME_TEXT_COLOR,
        },
        ...(disabled && { pointerEvents: "none" }),
      }}
      {...rest}
    />
  );
};

export default ThemedAutocomplete;
